$(window).load(function(){
  $('body').addClass('loaded');
});
$(window).scroll(function () {
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > windowHeight - 100){
				$("body").addClass("on");
            } else {
				$("body").removeClass("on");
			}
});
$(function(){
	$('.list-ac dt').click(function(){
		$(this).next('dd').slideToggle();
		$(this).toggleClass('open');
	});
	$('.sait-top a[href^=#]').click(function() {
		var speed = 800;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;

		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});

  $('#btn-popup').click(function(){
    		$('#popupInfotop').fadeIn();
  });
  $('#popupInfotop .close, #popupInfotop .closeBg').click(function(){
        $('#popupInfotop').fadeOut();
  });
});

$(function () {
    $('#blog-news').slick({
			dots: false,
			centerMode: true,
			arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
			speed: 1000
   });

  var list = $("#bnr-list a").length;
    if(list < 3){
    $('body').addClass('no-slide');
    }
    var ua = navigator.userAgent;
    if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0) {
      // スマートフォン用の記述

      	$('.template-page a[href^=#]').click(function() {
		var speed = 800;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - 70;

		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});
    $('#bnr-list').slick({
			autoplay: true,
			dots: false,
			centerMode: true,
			arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
			speed: 1000,
          autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 768, 
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
			centerMode: true,
			centerPadding: '18%',
        },
      },
    ],
   });

    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      // タブレット用の記述

	$('.template-page a[href^=#]').click(function() {
		var speed = 800;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - 150;

		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});
  if(list > 2){
    $('#bnr-list').slick({
			autoplay: true,
			dots: false,
			centerMode: true,
			arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
			speed: 1000,
          autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 768, 
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
			centerMode: true,
			centerPadding: '18%',
        },
      },
    ],
   });
 }
    } else {
      // PC用の記述

	$('.template-page a[href^=#]').click(function() {
		var speed = 800;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - 150;

		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});
      
  if(list > 2){
    $('#bnr-list').slick({
			autoplay: true,
			dots: false,
			centerMode: true,
			arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
			speed: 1000,
          autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: 768, 
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
			centerMode: true,
			centerPadding: '18%',
        },
      },
    ],
   });
 }
    }



});